import PropTypes from "prop-types";

export default PropTypes.shape({
  yourCompany: PropTypes.number,
  hiringHub: PropTypes.number,
  industryAvg: PropTypes.number,
});
